import { useState } from 'react'
import { InputObject } from './utils/InputObject';
import { Socket } from './utils/Socket';
import { ObjectSelector } from './utils/ObjectSelector'
import { getObject } from '../../../pages/ExperimentPlanner/api'
import c from './Dilution.module.css'

export const Dilution = () => {
  // Initial Stock
  const [selectedObjInitialStock, setSelectedObjInitialStock] = useState(null)
  const [noObjStockCi, setNoObjStockCi] = useState(0)
  const [noObjStockVi, setNoObjStockVi] = useState(0)
  
  // Final Stock
  const [selectedObjFinalStock, setSelectedObjFinalStock] = useState(null)
  const [noObjStockCf, setNoObjStockCf] = useState(0)
  const [noObjStockVf, setNoObjStockVf] = useState(0)


  const [dilutionProcesses, setDilutionProcesses] = useState([{
    id: `${Math.random() * 1000}-${Math.random() * 1000}`,
    vStockToAdd: 0,
    vDiluent: 0,
    dilutedVf: 0.0002,
    dilutedCf: 3
  }])

  const addDilutionProcess = (dilProcess) => {
    setDilutionProcesses([...dilutionProcesses, dilProcess])
  }

  const deleteDilutionProcess = (dilProcessId) => {
    setDilutionProcesses(dilutionProcesses.filter(dilProc => dilProc.id !== dilProcessId))
  }

  const updateDilutionProcess = (id, key, newValue) => {
    setDilutionProcesses(dilutionProcesses.map(dilProc => {
      if (dilProc.id === id) {
        return {
          ...dilProc,
          [key]: newValue
        }
      }
      return dilProc
    }))
  }

  const handleInitialStockChange = (id, newValue) => {
    switch (id) {
      case "stock_volume":
        setNoObjStockVi(newValue)
        break;
      case "stock_molar_conc":
        setNoObjStockCi(newValue)
        break
      default:
        break;
    }
  }
  const handleFinalStockChange = (id, newValue) => {
    switch (id) {
      case "stock_volume":
        setNoObjStockVf(newValue)
        break;
      case "stock_molar_conc":
        setNoObjStockCf(newValue)
        break
      default:
        break;
    }
  }

  const handleStockLinkedObjectChange = (rtSocketId, newValue) => {
    if (newValue) {
      getObject(newValue).then(data => {
        console.log(data)
        setSelectedObjInitialStock(data)
      })
    } else {
      setSelectedObjInitialStock(null)
    }
  }

  const handleDilutedChange = (dilProcId, id, newValue) => {
    updateDilutionProcess(dilProcId, id, newValue)
  }

  const handleToDiluteChange = (dilProcId, id, newValue) => {
    updateDilutionProcess(dilProcId, id, newValue)
  }

  const getMolarConcFromObject = (object) => {
    return object.attributes.find(attr => attr.dtId === 'tube_attr_content')
      .object.attributes.find(attr => attr.dtId === 'solution_attr__molar_concentration')
      .object.value
  }

  const getVolumeFromObject = (object) => {
    return object.attributes.find(attr => attr.dtId === 'tube_attr_content')
      .object.attributes.find(attr => attr.dtId === 'liquid_attr_volume')
      .object.value
  }

  const getLabelFromObject = (object) => {
    return object.attributes.find(attr => attr.dtId === 'tube_attr_label')
      .object.value

  }

  return (
    <div>
      <h2>Dilution</h2>
      <div><button onClick={() => {
        addDilutionProcess({
          id: `${Math.random() * 1000}-${Math.random() * 1000}`,
          vStockToAdd: 0,
          vDiluent: 0,
          dilutedVf: 2,
          dilutedCf: 3
        })
      }}>Add Solution To Dilute</button></div>
      <div>
        <h3>Input</h3>
        <div>
          <div className={c.rtProcess}>
            <Socket>
              <ObjectSelector
                id={"rt_socket_id"}
                selectedObject={selectedObjInitialStock}
                onChange={handleStockLinkedObjectChange}
              />
              <InputObject
                title={selectedObjInitialStock ? `Stock: ` + getLabelFromObject(selectedObjInitialStock) : "Stock"}
                inputs={[{
                  id: "stock_volume",
                  label: "Stock Vi",
                  baseUnit: 'L',
                  value: selectedObjInitialStock ? getVolumeFromObject(selectedObjInitialStock) : noObjStockVi,
                  disabled: selectedObjInitialStock ? true : false
                }, {
                  id: "stock_molar_conc",
                  label: "Stock Ci",
                  baseUnit: 'M',
                  value: selectedObjInitialStock ? getMolarConcFromObject(selectedObjInitialStock) : noObjStockCi,
                  disabled: selectedObjInitialStock ? true : false
                }]}
                onChange={handleInitialStockChange} />
            </Socket>
            {dilutionProcesses.map((dilProc, idx) => {
              return (
                <div className={c.rtProcess} key={idx}>
                  <Socket>
                    <InputObject
                      title="V(Stock) To Add"
                      inputs={[{
                        id: "vStockToAdd",
                        label: "V(Stock) To Add",
                        baseUnit: 'L',
                        value: dilProc.vStockToAdd ? dilProc.vStockToAdd : 0,
                        disabled: false
                      }]}
                      onChange={(id, newValue) => { handleToDiluteChange(dilProc.id, id, newValue) }} />
                  </Socket>
                  <Socket>
                    <InputObject
                      title="V(Diluent) To Add"
                      inputs={[{
                        id: "vDiluent",
                        label: "V(Diluent)",
                        baseUnit: 'L',
                        value: dilProc.vDiluent ? dilProc.vDiluent : 0,
                        disabled: false
                      }]}
                      onChange={(id, newValue) => { handleToDiluteChange(dilProc.id, id, newValue) }} />
                  </Socket>
                </div>)
            })}
          </div>
        </div>
        <h3>Output</h3>
        <div className={c.rtProcess}>
          <Socket>
            <InputObject
              title={selectedObjFinalStock ? `Stock: ` + getLabelFromObject(selectedObjFinalStock) : "Stock"}
              inputs={[{
                id: "stock_volume",
                label: "Stock Vf",
                baseUnit: 'L',
                value: selectedObjFinalStock ? getVolumeFromObject(selectedObjFinalStock) : noObjStockVf,
                disabled: selectedObjFinalStock ? true : false
              }, {
                id: "stock_molar_conc",
                label: "Stock Cf",
                baseUnit: 'M',
                value: selectedObjFinalStock ? getMolarConcFromObject(selectedObjFinalStock) : noObjStockCf,
                disabled: selectedObjFinalStock ? true : false
              }]}
              onChange={handleFinalStockChange} />
          </Socket>
          {dilutionProcesses.map((dilProc, idx) => {
            return (
              <div className={c.rtProcess} key={idx}>
                <div className={c.rtSocket}>
                  <InputObject
                    title={"Diluted"}
                    inputs={[{
                      id: "dilutedVf",
                      label: "Diluted Vf",
                      baseUnit: 'L',
                      value: dilProc.dilutedVf,
                      disabled: false
                    }, {
                      id: "dilutedCf",
                      label: "Diluted Cf",
                      baseUnit: 'M',
                      value: dilProc.dilutedCf,
                      disabled: false
                    }]}
                    onChange={(id, newValue) => { handleDilutedChange(dilProc.id, id, newValue) }} />
                </div>
              </div>)
          })}
        </div>
      </div>
    </div>
  )
}
